import { render } from "./ImportData.vue?vue&type=template&id=07b2de8a"
import script from "./ImportData.vue?vue&type=script&lang=js"
export * from "./ImportData.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\elder\\OneDrive\\Documents\\visual studio carpeta\\globaldashboard\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__